import React from 'react';
import styled from 'styled-components';
import { BackdropSpinner } from '@/components/backdrop-spinner';
import Portal from '@/components/portal';

export interface ChatImageTileProps {
  imageUrl: string;
  loading?: boolean;
  canZoom?: boolean;
  canDelete?: boolean;

  onDelete?: (url: string) => void;
}

export function ChatImageTile({
  imageUrl,
  loading,
  canZoom,
  canDelete,
  onDelete,
}: ChatImageTileProps) {
  const [isZoomed, setIsZoomed] = React.useState(false);

  const onDeleteClicked = (ev) => {
    if (canDelete && !loading) {
      ev.stopPropagation();
      onDelete(imageUrl);
    }
  };

  const onImageClicked = () => {
    if (canZoom && !loading) {
      setIsZoomed((prev) => !prev);
    }
  };

  const onCloseZoom = () => {
    setIsZoomed(false);
  };

  const onZoomBackgroundClicked = (ev) => {
    if (ev?.target?.nodeName?.toLowerCase() !== `img`) {
      setIsZoomed(false);
    }
  };

  return (
    <>
      <Wrapper style={{ cursor: !loading && canZoom ? `zoom-in` : `default` }}>
        {canDelete && !loading && (
          <DeleteButton onClick={onDeleteClicked}>✕</DeleteButton>
        )}
        {loading && (
          <BackdropSpinner
            loading
            blurAmount={0}
            spinnerSize={30}
            backgroundColor="rgba(0,0,0,0.2)"
          />
        )}
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt,jsx-a11y/no-noninteractive-element-interactions */}
        <img src={imageUrl} alt="Chat Image" onClick={onImageClicked} />
      </Wrapper>
      {isZoomed && (
        <Portal selector="#___gatsby">
          <FullScreenWrapper onClick={onZoomBackgroundClicked}>
            <DeleteButton className="zoom-close" onClick={onCloseZoom}>
              ✕
            </DeleteButton>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img src={imageUrl} alt="Chat Image" />
          </FullScreenWrapper>
        </Portal>
      )}
    </>
  );
}

const Wrapper = styled.div`
  position: relative;
  height: 8rem;
  width: 8rem;
  overflow: hidden;

  border: 1px solid #a6afb8;
  border-radius: 1rem;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  top: 0.2rem;
  right: 0.2rem;

  height: 1.8rem;
  width: 1.8rem;

  background: black;
  color: white;
  border-radius: 50%;
  font-size: 1rem;

  cursor: pointer;

  &&:hover {
    opacity: 0.8;
  }

  &&:active {
    opacity: 0.6;
  }
`;

const FullScreenWrapper = styled.div`
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000000;

  background: rgba(0, 0, 0, 0.8);

  display: flex;
  justify-content: center;
  align-items: center;

  .zoom-close {
    top: 2rem;
    right: 2rem;
    height: 3rem;
    width: 3rem;
    font-size: 1.4rem;
  }

  img {
    //width: 90vw;
    max-width: 90vw;
    height: auto;
    max-height: 90vh;
    object-fit: contain;
  }
`;
